import { render } from "./ProfessionCostView.vue?vue&type=template&id=13485757&scoped=true"
import script from "./ProfessionCostView.vue?vue&type=script&lang=js"
export * from "./ProfessionCostView.vue?vue&type=script&lang=js"

import "./ProfessionCostView.vue?vue&type=style&index=0&id=13485757&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13485757"]])

export default __exports__